import React, {ReactNode} from 'react';

export const Card = ({ title, children }: { title: string, children: ReactNode }) => {
  return (
    <div className='flex flex-col bg-white rounded-lg'>
      <span className='flex items-center h-14 border-b border-slate-200 px-6 font-bold'>{ title }</span>
      <div className='p-6'>
        { children }
      </div>
    </div>
  );
};